import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import DiscountsShow from './DiscountsShow';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import fetchResourceById from 'components/hoc/fetchResourceById';
import { fetchDiscount } from 'store/actions/discounts/fetchDiscounts';
import { connect } from 'react-redux';
import { exportDiscountCodes } from 'store/actions/discountCodes/exportDiscountCodes';

const DiscountsShowContainer = (props) => {
    const {
        data,
        exportDiscountCodes,
        history,
        id,
        resource,
        resourceFetchFailed,
        resourceFetchLoading,
    } = props;

    const handleExport = () => {
        exportDiscountCodes({
            filters: {
                discount_id: [
                    id,
                ],
            },
        });
    };

    if (resourceFetchLoading) {
        return <LoadingCard />;
    }

    if (resourceFetchFailed) {
        return <ResourceNotFound />;
    }

    if (!data) {
        return null;
    }

    return (
        <DiscountsShow
            history={ history }
            id={ id }
            record={ data }
            resource={ resource }
            handleExport={ handleExport }
        />
    );

};

DiscountsShowContainer.propTypes = {
    data: PropTypes.object,
    exportDiscountCodes: PropTypes.func,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string.isRequired,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const enhance = compose(
    connect(
        null,
        {
            exportDiscountCodes: exportDiscountCodes,
        },
    ),
    fetchResourceById({
        resource: 'discounts',
        action: fetchDiscount,
    }),
);

export default enhance(DiscountsShowContainer);



// WEBPACK FOOTER //
// ./src/pages/discounts/show/DiscountsShowContainer.js